import { httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/travel-type'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'Application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  setDefaults ({commit, dispatch}, payload) {
    let url = 'api/categories/generated-categories'
    let params = {
      'core_company_id': store.state.userLogged.company[0].id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onDefaults', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({commit, dispatch}, payload) {
    let url = 'api/travel-type'
    let params = {
      'name': payload.event.item.name
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put ({commit, dispatch}, payload) {
    let url = 'api/travel-type/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({commit, dispatch}, payload) {
    let url = 'api/travel-type/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let travelTypes = payload.response.data.data
    payload.event.context.travelTypes = travelTypes
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  },
  onDefaults (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.loading = false
    payload.event.context.defaultsLoaded = true
    payload.event.context.confirmTravelTypeDialog = false
    payload.event.context.getTravelTypes()
  },
  onPost (state, payload) {
    payload.event.context.initialize()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onPut (state, payload) {
    // let category = payload.response.data.data
    // let categories = payload.event.context.categories
    // var index = 0
    // let found = categories.find((elm, i) => {
    //   if (elm.default) {
    //     index = i
    //     elm.default = false
    //     return elm
    //   }
    // })
    // categories.splice(index, 1, found)
    // categories.splice(payload.event.index, 1, category)
    payload.event.context.initialize()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  onDelete (state, payload) {
    // let categories = payload.event.context.categories
    // categories.splice(payload.event.index, 1)
    payload.event.context.initialize()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeRemove()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/travelTypes.js